/* global arNextOptions, jsPriceFormat */
import {refreshBasketFly} from './refresh-basket-fly';

(function () {
    let timerBasketUpdate = null;

    function getInput(id) {
        return document.querySelector(`#QUANTITY_INPUT_${id}`);
    }

    function getSelect(id) {
        return document.querySelector(`#QUANTITY_SELECT_${id}`);
    }

    function getHidden(id) {
        return document.querySelector(`#QUANTITY_${id}`);
    }

    function isFloat(input) {
        return input?.dataset?.float_ratio === 'true';
    }

    function setQuantityFly(basketId, ratio, direction) {
        const input = getInput(basketId);
        if (!input) return;

        const currentValue = input.value;
        const isDblQuantity = isFloat(input);

        let step = isDblQuantity ? parseFloat(ratio) : parseInt(ratio, 10);

        if (isDblQuantity && window.arNextOptions?.JS_ITEM_CLICK?.precisionFactor) {
            step =
                Math.round(step * arNextOptions.JS_ITEM_CLICK.precisionFactor) /
                arNextOptions.JS_ITEM_CLICK.precisionFactor;
        }

        let curValue = isDblQuantity ? parseFloat(currentValue) : parseInt(currentValue, 10);
        const max = parseFloat(input.getAttribute('max')) || Infinity;

        if (direction === 'up' && curValue >= max) {
            return;
        }

        curValue = direction === 'up' ? curValue + step : curValue - step;

        if (curValue > max) {
            curValue = max;
        }
        if (curValue < 1) return;
        if (isDblQuantity && window.arNextOptions?.JS_ITEM_CLICK?.precisionFactor) {
            curValue =
                Math.round(curValue * arNextOptions.JS_ITEM_CLICK.precisionFactor) /
                arNextOptions.JS_ITEM_CLICK.precisionFactor;
        }

        input.value = curValue;
        input.defaultValue = currentValue;

        recalcLocalTotals(basketId);

        if (timerBasketUpdate) {
            clearTimeout(timerBasketUpdate);
        }

        timerBasketUpdate = setTimeout(() => {
            updateQuantityFly(basketId, step);
            timerBasketUpdate = null;
        }, 700);
    }

    function recalcLocalTotals() {
        let totalSum = 0;

        const rows = document.querySelectorAll(`#basket_line .basket_fly tr[data-id]`);

        rows.forEach((row) => {
            const id = row.getAttribute('data-id');
            const input = getInput(id);
            const priceInput = document.querySelector(`#basket_form input[name="item_price_${id}"]`);

            if (!input || !priceInput) return;

            const count = parseFloat(input.value) || 0;
            const price = parseFloat(priceInput.value) || 0;

            const sum = count * price;
            totalSum += sum;

            const priceCell = row.querySelector('.summ-cell .price');

            if (priceCell && window.jsPriceFormat) {
                priceCell.innerHTML = jsPriceFormat(sum);
            }
        });

        const totalEl = document.querySelector('#basket_form .itog span.price');

        if (totalEl && window.jsPriceFormat) {
            totalEl.innerHTML = jsPriceFormat(totalSum);
        }

        const discountEl = document.querySelector('#basket_form .itog div.discount');

        if (discountEl) {
            discountEl.style.opacity = '0.2';
        }
    }

    async function updateQuantityFly(basketId, ratio) {
        const input = getInput(basketId);
        if (!input) return;

        let newVal = parseFloat(input.value) || 0;

        if (newVal < 0) {
            newVal = 0;
        }

        const isIntRatio = ratio % 1 === 0;

        if (isIntRatio) {
            newVal = parseInt(newVal, 10);
        } else {
            newVal = parseFloat(newVal).toFixed(1);
        }

        const select = getSelect(basketId);

        if (select) {
            Array.from(select.options).forEach((option) => {
                if (parseFloat(option.value).toFixed(2) === parseFloat(newVal).toFixed(2)) {
                    option.selected = true;
                }
            });
        }

        const hidden = getHidden(basketId);
        if (hidden) hidden.value = newVal;

        input.value = newVal;

        const form = document.querySelector('form[name^="basket_form"]');

        if (!form) return;

        const body = new URLSearchParams(new FormData(form));
        body.append('BasketRefresh', 'Y');

        try {
            const response = await fetch(`${window.arNextOptions.SITE_DIR}ajax/basket_fly.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                },
                body,
            });

            if (!response.ok) return;

            await refreshBasketFly();
        } catch (e) {
            console.error('Quantity update failed', e);
        }
    }

    window.setQuantityFly = setQuantityFly;
    window.updateQuantityFly = updateQuantityFly;
})();
